<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="lg" :visible="modal.show" :title="computedTitle" @hidden="onHidden"
                   @hide="onHide" hide-footer
                   :ok-title="$t('Submit')" :is-loading="loading" :content-in-form="false" scrollable>

      <div class="row">
        <div class="col-md-12 mb-3" v-if="auctionRows.length > 0">
          <div class="card">
            <div class="card-header">
              <h5 class="mb-0" v-if="!enableContinuousAuction">{{ $t("Lots / Reservations") }}</h5>
              <h5 class="mb-0" v-else>{{ $t("Lots") }}</h5>
            </div>
            <div class="card-body">
              <table class="table table-sm mb-0">
                <tr>
                  <th v-if="!enableContinuousAuction" class="border-top-0" style="width: 25%">{{ $t('Sale') }}</th>
                  <th class="border-top-0" style="width: 25%">{{ $t('Lot') }}</th>
                  <th class="border-top-0" style="width: 20%">{{ $t('Status') }}</th>
                  <th class="border-top-0" style="width: 25%">{{ $t('Invoice') }}</th>
                  <th class="border-top-0" style="width: 15%">{{ $t('Collected') }}</th>
                  <th class="border-top-0" style="width: 15%">{{ $t('Quantity') }}</th>
                </tr>
                <tr v-for="(item, index) in auctionRows" :key="`${item.auction_uuid}-${index}`">
                  <td v-if="!enableContinuousAuction">
                    <template v-if="$hasPermission('change_auction')">
                      <a href="javascript:void(0)" @click="onAuctionViewClick(item)">{{ item.sale_no }}</a>
                    </template>
                    <template v-else>
                      <span>{{ item.sale_no }}</span>
                    </template> - {{ item.auction_title | masterLanguage | striptags | truncate(50) }}
                  </td>
                  <td>
                    <a href="javascript:void(0)" v-if="$hasPermission('view_inventoryitem')"
                       @click="onLotViewClick(item)">
                      {{ item.lot_no }}
                    </a>
                    <span v-else>
                      {{ item.lot_no }}
                    </span>
                  </td>
                  <td>
                    <span v-as-status="item.status">{{ item.status | toUpperCaseFirst }}</span>
                  </td>
                  <td class="d-flex align-items-center">
                    <template v-if="item.invoice_number">
                      {{ item.invoice_number }}
                      <span class="ml-1 mr-1">-</span>
                      <span v-as-status="item.invoice_status">
                      {{ item.invoice_status | toUpperCaseFirst }}
                    </span>
                    </template>
                    <template v-else>
                      <span v-as-status="item.invoice_status">N/A</span>
                    </template>
                  </td>
                  <td>
                    <span class="badge badge-success" v-if="item.collected">{{ $t("Yes") }}</span>
                    <span class="badge badge-danger" v-else>{{ $t("No") }}</span>
                  </td>
                  <td>
                    {{ item.quantity }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>

        <div class="col-md-12 mb-3" v-if="manualRows && manualRows.length > 0">
          <div class="card">
            <div class="card-header">
              <h5 class="mb-0">{{ $t("Manual Invoices") }}</h5>
            </div>
            <div class="card-body">
              <table class="table table-sm mb-0">
                <tr>
                  <th class="border-top-0" style="width: 25%">{{ $t('Invoice') }}</th>
                  <th class="border-top-0" style="width: 15%">{{ $t('Collected') }}</th>
                  <th class="border-top-0">{{ $t('Quantity') }}</th>
                </tr>
                <tr v-for="(item, index) in manualRows" :key="`manual-row-${index}`">
                  <td>
                    <template v-if="item.invoice_number">
                      {{ item.invoice_number }}
                      <span class="ml-1 mr-1">-</span>
                      <span v-as-status="item.invoice_status">
                        {{ item.invoice_status | toUpperCaseFirst }}
                      </span>
                    </template>
                  </td>
                  <td>
                    <span class="badge badge-success" v-if="item.collected">{{ $t("Yes") }}</span>
                    <span class="badge badge-danger" v-else>{{ $t("No") }}</span>
                  </td>
                  <td>
                    {{ item.quantity }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>

    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import ArtisioModal from "../../core/components/artisio-modal/ArtisioModal";
  import {createNamespacedHelpers} from "vuex";

  const {mapState: globalMapState} = createNamespacedHelpers('global');

  const {mapState, mapActions} = createNamespacedHelpers('inventory');

  export default {
    name: "InventoryStatusesModal",
    components: {
      ArtisioModal
    },
    data() {
      return {
        loading: false,
      }
    },
    computed: {
      ...globalMapState({
        enableContinuousAuction: state => state.enableContinuousAuction,
      }),
      ...mapState({
        modal: state => state.inventoryStatusesModal,
        inventory: state => state.inventoryStatusesModal.inventory,
        statusKey: state => state.inventoryStatusesModal.statusKey,
      }),
      computedTitle() {
        return this.$i18n.t("Inventory Information")
      },
      auctionRows() {
        if (!this.inventory || !this.inventory[this.statusKey]) {
          return []
        }
        return this.inventory[this.statusKey].filter(s => s.type === 'auction')
      },
      manualRows() {
        if (!this.inventory || !this.inventory[this.statusKey]) {
          return []
        }
        return this.inventory[this.statusKey].filter(s => s.type === 'manual')
      }
    },
    methods: {
      ...mapActions(['hideInventoryStatusesModal']),
      onHide() {
        this.hideInventoryStatusesModal()
      },
      onHidden() {
        this.hideInventoryStatusesModal();
      },
      onAuctionViewClick(item) {
        this.$router.push({name: 'sales.dashboard', params: {id: item.auction_uuid}})
        this.hideInventoryStatusesModal()
      },
      onLotViewClick(item) {
        this.$router.push({name: 'reservations.view', params: {id: item.inventory_item_reservation_uuid}})
        this.hideInventoryStatusesModal()
      }
    },
  }
</script>

<style scoped>

</style>
